// this file is duplicated in catalog, it will be moved to modules in next Braze iteration

export const setTodayDateAtMidnight = (): Date => {
    const date = new Date();
    date.setHours(23, 59, 59, 0);

    return date;
};

// temporary here, @pegasus/utils will be extended with this
export const removeSessionStorageItem = (key: string): boolean => {
    try {
        window.sessionStorage.removeItem(key);

        return true;
    } catch (_) {
        return false;
    }
};
